import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchedSpecialityFragment = (
  { __typename?: 'Speciality' }
  & Pick<Types.Speciality, 'id' | 'objectId' | 'name'>
  & { relatedProfessions: (
    { __typename?: 'ProfessionConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ProfessionEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Profession' }
        & Pick<Types.Profession, 'id' | 'objectId' | 'name'>
      )> }
    )>>> }
  ) }
);

export type GetSpecialityFromLabelQueryVariables = Types.Exact<{
  specialityLabel: Types.Scalars['String']['input'];
}>;


export type GetSpecialityFromLabelQuery = (
  { __typename?: 'Query' }
  & { specialities: (
    { __typename?: 'SpecialityConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'SpecialityEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Speciality' }
        & Pick<Types.Speciality, 'id' | 'objectId' | 'name'>
        & { relatedProfessions: (
          { __typename?: 'ProfessionConnection' }
          & { edges?: Types.Maybe<Array<Types.Maybe<(
            { __typename?: 'ProfessionEdge' }
            & { node?: Types.Maybe<(
              { __typename?: 'Profession' }
              & Pick<Types.Profession, 'id' | 'objectId' | 'name'>
            )> }
          )>>> }
        ) }
      )> }
    )>>> }
  ) }
);

export const FetchedSpecialityFragmentDoc = gql`
    fragment FetchedSpeciality on Speciality {
  id
  objectId
  name
  relatedProfessions {
    edges {
      node {
        id
        objectId
        name
      }
    }
  }
}
    `;
export const GetSpecialityFromLabelDocument = gql`
    query getSpecialityFromLabel($specialityLabel: String!) {
  specialities(where: {name: {equalTo: $specialityLabel}}, first: 1) {
    edges {
      node {
        ...FetchedSpeciality
      }
    }
  }
}
    ${FetchedSpecialityFragmentDoc}`;

/**
 * __useGetSpecialityFromLabelQuery__
 *
 * To run a query within a React component, call `useGetSpecialityFromLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialityFromLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialityFromLabelQuery({
 *   variables: {
 *      specialityLabel: // value for 'specialityLabel'
 *   },
 * });
 */
export function useGetSpecialityFromLabelQuery(baseOptions: Apollo.QueryHookOptions<GetSpecialityFromLabelQuery, GetSpecialityFromLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecialityFromLabelQuery, GetSpecialityFromLabelQueryVariables>(GetSpecialityFromLabelDocument, options);
      }
export function useGetSpecialityFromLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialityFromLabelQuery, GetSpecialityFromLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecialityFromLabelQuery, GetSpecialityFromLabelQueryVariables>(GetSpecialityFromLabelDocument, options);
        }
export type GetSpecialityFromLabelQueryHookResult = ReturnType<typeof useGetSpecialityFromLabelQuery>;
export type GetSpecialityFromLabelLazyQueryHookResult = ReturnType<typeof useGetSpecialityFromLabelLazyQuery>;
export type GetSpecialityFromLabelQueryResult = Apollo.QueryResult<GetSpecialityFromLabelQuery, GetSpecialityFromLabelQueryVariables>;